import graphql__d5cb0a8164d6a91d3664 from "./__generated__/MapFilterTaxonomy_filter.graphql.js";import { useCallback, useEffect, useMemo, useState } from "react";
import { graphql, useFragment } from "react-relay";
import { useDispatch, useSelector } from "react-redux";
import includes from "lodash/includes";

import { useMapContext } from "../MapContext";
// TODO : Change the "Taxonomy" naming of this feature to avoid mixing resource taxonomies
//        and map element ones.
import MapFilterTaxonomyFilterWithChildren from "./MapFilterTaxonomy/MapFilterTaxonomyFilterWithChildren";
import MapFilterTaxonomyFilterWithoutChildren from "./MapFilterTaxonomy/MapFilterTaxonomyFilterWithoutChildren";

import {
  initiallyOpenDropdownIdsFor,
  selectableTaxonomyIdsFor,
  taxonomySelectionAfterClick
} from "./MapFilterTaxonomy/taxonomySelection";

import {
  initialActiveIdsFor,
  initializeFilterSelection,
  setTaxonomyFilterSelection
} from "../../../reducers/map/filters";

const MapFilterTaxonomy = props => {
  const filter = useFragment(MapFilterTaxonomy_filter, props.filter);
  const {
    id: filterId,
    mapTaxonomies,
    filterElementsOutOnInitialize,
    allowSelectingMultipleTaxonomies
  } = filter;
  const { mapKey } = useMapContext();

  const selectableTaxonomyIds = useMemo(
    () => selectableTaxonomyIdsFor(mapTaxonomies),
    [mapTaxonomies]
  );

  const activeTaxonomyIds = useSelector(
    ({ map }) => map[mapKey].filters.byFilterId[filterId]?.activeTaxonomyIds
  );

  const [openDropdowns, setOpenDropdowns] = useState(() =>
    initiallyOpenDropdownIdsFor(mapTaxonomies, filterElementsOutOnInitialize)
  );
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      initializeFilterSelection(mapKey, filterId, {
        activeTaxonomyIds: initialActiveIdsFor(
          filterElementsOutOnInitialize,
          selectableTaxonomyIds
        )
      })
    );
  }, [dispatch, filterElementsOutOnInitialize, filterId, mapKey, selectableTaxonomyIds]);

  const isDropdownOpen = useCallback(
    mapTaxonomy => includes(openDropdowns, mapTaxonomy.id),
    [openDropdowns]
  );

  // The selectors only report the id of the taxonomy that was clicked, as Relay masks the
  // fields their own fragments don't declare. The resulting selection is computed as a
  // whole by `taxonomySelectionAfterClick`, so this callback only applies it.
  const handleFilterSelectorClick = useCallback(
    mapTaxonomyId => {
      const updatedSelection = taxonomySelectionAfterClick({
        mapTaxonomies,
        mapTaxonomyId,
        activeTaxonomyIds,
        openDropdowns,
        allowSelectingMultipleTaxonomies
      });

      dispatch(
        setTaxonomyFilterSelection(mapKey, filterId, updatedSelection.activeTaxonomyIds)
      );
      setOpenDropdowns(updatedSelection.openDropdowns);
    },
    [
      activeTaxonomyIds,
      allowSelectingMultipleTaxonomies,
      dispatch,
      filterId,
      mapKey,
      mapTaxonomies,
      openDropdowns
    ]
  );

  return (
    <div className="map-filter map-filter-taxonomy">
      {mapTaxonomies.map(mapTaxonomy => {
        const { id: taxonomyId, hasChildren } = mapTaxonomy;

        if (hasChildren) {
          return (
            <MapFilterTaxonomyFilterWithChildren
              key={taxonomyId}
              filterId={filterId}
              initiallyActive={!filterElementsOutOnInitialize}
              mapTaxonomy={mapTaxonomy}
              onFilterSelectorClicked={handleFilterSelectorClick}
              isOpen={isDropdownOpen(mapTaxonomy)}
            />
          );
        } else {
          return (
            <MapFilterTaxonomyFilterWithoutChildren
              key={taxonomyId}
              filterId={filterId}
              initiallyActive={!filterElementsOutOnInitialize}
              mapTaxonomy={mapTaxonomy}
              onFilterSelectorClicked={handleFilterSelectorClick}
            />
          );
        }
      })}
    </div>
  );
};

const MapFilterTaxonomy_filter = graphql__d5cb0a8164d6a91d3664;

export default MapFilterTaxonomy;
